module.exports = __webpack_public_path__ + "img/banner.1864aa4b.png";